// Explorer.... //
document.currentScript = document.currentScript || (function () {
  var scripts = document.getElementsByTagName("script");
  return scripts[scripts.length - 1];
})();
// END //

/** PATH to retrieve the specs */
const defaultPath = "https://visionnaire-core.procne.cloud/web-component-script.js";
const environmentPath = "https://cpq.visionnaire-home.com/api/public/frontend/utilities/vesta/env";
/**
 * Generates the script tag and appends it to the DOM
 * @param url
 */
var appendScript = function (url, option = "") {
   console.info("Appending webComponent script");
  var head = document.getElementsByTagName("head")[0];
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  if (option) {
    const options = option.split(" ");
    options.forEach(option => {
      const split = option.split("\"").join("").split("=");
      script.setAttribute(split[0], split[1] || "");
    });
  }
  head.appendChild(script);
};

function callVesta3DManager(url) {
  const http = new XMLHttpRequest();
  http.open("GET", url);
  http.send();
  http.onload = () => {
    const response = JSON.parse(http.responseText).data;
    const links = response.links;
    const scripts = response.scripts;

    links.forEach(element => {
      appendScript(element);
    });

    scripts.forEach(element => {
      appendScript(element.resource.url, element.option);
    });
  };
}

/**
 * Performs a call to the server to retieve the webComponent's data and path to load
 * @param path: string, the path for the API
 */
var getPath = function () {
//    console.info("Getting path of webcomponent");
  const envHttp = new XMLHttpRequest();
  envHttp.open("GET", environmentPath);
  envHttp.send();
  envHttp.onload = () => {
    const url = envHttp.responseText;
    if (envHttp.status === 200 && url) {
      appendScript([url, 'web-component-script.js'].join('/'));
    } else {
      appendScript(defaultPath);
    }
  };
};

/*
const forcedVersion = document.currentScript.getAttribute('version');
const forcedPath = document.currentScript.getAttribute('path'); //?
    // exstract data from tags, like:
    // <script type="text/javascript" src="http://local.airnova.test/js/web-component/webcomponent-loader.js" version="42" path="pippo"></script>
*/

// console.info("Starting retrieving webComponent data...");
getPath();
